import ApiStatus from "../constants/api-status.enum";
import { DndRegistrationActionType } from "../actiontype/dnd-registration.actiontype";

const initialState = {
    fetchDndMappingAndPreferencesApiStatus: '',
    fetchDndMappingAndPreferencesApiResponse: '',
    fetchDndMappingApiStatus: '',
    fetchDndMappingApiResponse: '',
    dndRegistrationApiStatus: '',
    dndRegistrationResponse: '',
    dndPreferences: '',
    dndMapping: '',
    preferenceList: [],
    selectedPreferenceList: {},
    categorywiseSelectedPreferenceList: {},
    openAdvance: false,
    enableMorePreferences: true
}

export default function(state = initialState, action) {
    switch(action.type) {
        case DndRegistrationActionType.FETCH_DND_MAPPING_AND_PREFERENCES_LOADING:
        return {
            ...state,
            fetchDndMappingAndPreferencesApiStatus: ApiStatus.LOADING,
            fetchDndMappingAndPreferencesApiResponse: action.payload
        }
        case DndRegistrationActionType.FETCH_DND_MAPPING_AND_PREFERENCES_SUCCESS:
        return {
            ...state,
            fetchDndMappingAndPreferencesApiStatus: ApiStatus.SUCCESS,
            fetchDndMappingAndPreferencesApiResponse: action.payload
        }
        case DndRegistrationActionType.FETCH_DND_MAPPING_AND_PREFERENCES_ERROR:
        return {
            ...state,
            fetchDndMappingAndPreferencesApiStatus: ApiStatus.ERROR,
            fetchDndMappingAndPreferencesApiResponse: action.payload
        }
        case DndRegistrationActionType.FETCH_DND_MAPPING_LOADING:
        return {
            ...state,
            fetchDndMappingAndPreferencesApiStatus: ApiStatus.LOADING,
            fetchDndMappingAndPreferencesApiResponse: action.payload
        }
        case DndRegistrationActionType.FETCH_DND_MAPPING_SUCCESS:
        return {
            ...state,
            fetchDndMappingAndPreferencesApiStatus: ApiStatus.SUCCESS,
            fetchDndMappingAndPreferencesApiResponse: action.payload
        }
        case DndRegistrationActionType.FETCH_DND_MAPPING_ERROR:
        return {
            ...state,
            fetchDndMappingAndPreferencesApiStatus: ApiStatus.ERROR,
            fetchDndMappingAndPreferencesApiResponse: action.payload
        }
        case DndRegistrationActionType.DND_REGISTRATION_MOBILE_LOADING:
        return {
            ...state,
            dndRegistrationApiStatus: ApiStatus.LOADING,
            dndRegistrationResponse: action.payload
        }
        case DndRegistrationActionType.DND_REGISTRATION_MOBILE_SUCCESS:
        return {
            ...state,
            dndRegistrationApiStatus: ApiStatus.SUCCESS,
            dndRegistrationResponse: action.payload
        }
        case DndRegistrationActionType.DND_REGISTRATION_MOBILE_ERROR:
        return {
            ...state,
            dndRegistrationApiStatus: ApiStatus.ERROR,
            dndRegistrationResponse: action.payload
        }
        case DndRegistrationActionType.SET_DND_PREFERENCES: 
        return {
            ...state,
            dndPreferences: action.payload
        }
        case DndRegistrationActionType.SET_DND_MAPPING: 
        return {
            ...state,
            dndMapping: action.payload
        }
        case DndRegistrationActionType.SET_PREFERENCE_LIST:
        return {
            ...state,
            preferenceList: action.payload
        }
        case DndRegistrationActionType.SET_SELECTED_PREFERENCE_LIST:
        return {
            ...state,
            "selectedPreferenceList": {...state.selectedPreferenceList, ...action.payload}
            // selectedPreferenceList: action.payload
        }
        case DndRegistrationActionType.SET_CATEGORY_WISE_PREFERENCE_LIST:
        return {
            ...state,
            categorywiseSelectedPreferenceList: action.payload
        }
        case DndRegistrationActionType.TOGGLE_ADVANCE:
        return {
            ...state,
            openAdvance: !state.openAdvance
        }
        case DndRegistrationActionType.CLOSE_ADVANCE:
        return {
            ...state,
            openAdvance: false
        }
        case DndRegistrationActionType.ENABLE_MORE_PREFERENCES: 
        return {
            ...state,
            enableMorePreferences: action.payload
        }
        default:
        return state;
    }
}